<!--村级待公示 -->
<template>
  <div style="width: 100%">
    <div class="searchcontent">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入申请人姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.id_number" placeholder="请输入申请人证件号" maxlength="18" onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- 乡级以上 -->
          <el-cascader v-if="this.currentUserRegionLevel<=4" size="small" :props="{ checkStrictly: true }" v-model="searchForm.value" :options="options" :show-all-levels="false" @active-item-change="handleItemChange" clearable placeholder="请选择区划地区" @change="handleCateChange">
          </el-cascader>
          <!-- 村级 -->
          <el-input size="small" v-model.trim="searchForm.value1" :placeholder="searchForm.villagename" v-else :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model="searchForm.nodeID" placeholder="请选择公示状态" clearable @change="changeNodeHandle" value-key="nodeID">
            <el-option v-for="(item,index) in searchForm.publicStatusList" :key="index" :label="item.nodeName" :value="item.nodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker size="small" v-model="searchForm.publicity_end_time" type="date" placeholder="请选择公示结束时间" value-format="timestamp" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearchForm">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="permission.isHavetownshippublicitylistwordPermission" size="small" plain type="primary" icon="el-icon-upload2" @click="exportfile">导出公示名单</el-button>
          <el-button v-else size="small" plain type="primary" icon="el-icon-upload2" @click="exportfile" disabled>导出公示名单
          </el-button>
        </el-form-item>
        <el-form-item>
          <div class="uploadFile" style="width: 50%">
            <el-upload :disabled="authenStatus == 0 ? true : false" ref="my-upload" class="upload-demo" :action="uploadUrl" :headers="uploadheaders" multiple :limit="9" accept=".jpg, .jpeg, .png" :on-success="haneditVideoSuccess" :before-upload="beforeUpload" :data="{ sourceType: sourceType, timestamp: tiem, _sign: sign }" :file-list="fileList" :show-file-list="false" :on-exceed="handleExceed" :on-change="handFileChange">
              <el-button size="small" plain icon="el-icon-picture-outline" v-if="permission.isHaveSubmitPermission" type="primary" @click="submitUpload">上传公示照片</el-button>
              <el-button size="small" plain icon="el-icon-picture-outline" type="primary" v-else disabled>上传公示照片
              </el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button v-if="permission.isHaveFinishPermission" size="small" plain type="primary" icon="el-icon-check" @click="completeCheckHandle">完成公示</el-button>
          <el-button size="small" plain type="primary" icon="el-icon-check" v-else disabled @click="completeCheckHandle">完成公示
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="searchtable">
      <el-table ref="table" :data="applyaudituserlist" border stripe v-loading="showDataLoading" :header-row-style="{ height: '30px' }" :header-cell-style="{ padding: '5px' }" :row-style="{ height: '30px' }" :cell-style="{ padding: '5px' }" @selection-change="handleSelectionChange" :height="tableHeight">
        <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
        <el-table-column prop="" label="编号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="applyTypeName" label="申请方式" width="100">
        </el-table-column>
        <el-table-column prop="realName" label="申请人姓名" width="100">
        </el-table-column>

        <el-table-column prop="" label="性别" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.sexID == 1">男</span>
            <span v-if="scope.row.sexID == 2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="userBirthday" label="出生年月" width="100">
        </el-table-column>
        <el-table-column prop="certificateNo" label="身份证号" width="165">
        </el-table-column>
        <el-table-column prop="maritalStatus" label="婚姻状况" width="85">
          <!-- 1初婚；2再婚；3离婚；4丧偶 -->
          <template slot-scope="scope">
            <span v-if="scope.row.maritalStatus == 1">初婚</span>
            <span v-if="scope.row.maritalStatus == 2">再婚</span>
            <span v-if="scope.row.maritalStatus == 3">离婚</span>
            <span v-if="scope.row.maritalStatus == 4">丧偶</span>
          </template>
        </el-table-column>

        <el-table-column prop="enjoyCensusAddress" label="享受地户籍" min-width="180">
        </el-table-column>
        <el-table-column prop="surviveChildrenNum" label="现子女数" width="85">
        </el-table-column>
        <el-table-column prop="contactTel" label="联系电话" width="120">
        </el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="100">
        </el-table-column>
        <el-table-column prop="publicityStatusName" label="公示状态" width="85">
        </el-table-column>
        <el-table-column prop="applyTime" label="公示时间" width="100">
          <template slot-scope="scope">
            <span style="word-break:normal;width:auto; display:block;  white-space:pre-wrap;word-wrap : break-word ; overflow: hidden;">{{scope.row.publicityStartTime
              | dateFormate }}{{scope.row.publicityEndTime!=''?'\n至\n':''}}{{ scope.row.publicityEndTime |
              dateFormate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" label="剩余公示时间" width="110">
          <template slot-scope="scope">
            {{scope.row.publicityEndTime | getRemainingDays}}
          </template>
        </el-table-column>
        <el-table-column prop="galleryCount" label="公示图集" width="85">
          <template slot-scope="scope">
            <span>
              <el-link @click="getGalleryl(scope.row)" type="primary" :disabled="!permission.lookvillageshipapplypublicitygalleryinfolist003">图集
                <!-- ({{ scope.row.galleryCount }}) -->
              </el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editFunds(scope.row)">查看资料</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageblock">
        <el-pagination @size-change="handledatailSizeChange" @current-change="handledatailCurrentChange" :current-page="pageIndex" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!-- 查看资料 -->
    <el-dialog title="查看资料" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :visible.sync="dialogdataFormVisible" class="eldialog" :modal-append-to-body="true" append-to-body :style="'margin-top:0px;left:' + initLeft()" @close="clearlookoverList()">
      <NationAwardParticulars :valueID="applyRecordID" :indexID="keyindex" :markID="mark" :markshow="markshowID" :markauditStatus="markauditStatusID" :markuser="markuserID" :markpolicyMeasure="markpolicyMeasureID" :markrewardRecord="markrewardRecordID" :filterShowdata="dialogdataFormVisible" :permission="permission" @getStatedata="getTypedata" :auditRecordType="auditRecordType"></NationAwardParticulars>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 公示列表图集 -->
    <el-dialog title="公示图集" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" width="100%" style="margin-top: 0px; margin: 0 aotu" :visible.sync="dialogImglistVisible" class="eldialog" :style="'margin-top:0px;left:' + initLeft()">
      <div class="searchtable">
        <el-table ref="table" :data="gallerylist" border stripe :v-loading="showDataLoadingimg" :header-row-style="{ height: '30px' }" :header-cell-style="{ padding: '5px' }" :row-style="{ height: '30px' }" :cell-style="{ padding: '5px' }">
          <el-table-column prop="infoID" label="编号" width="100">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="公示图片" min-width="350">
            <template slot-scope="scope">
              <el-popover placement="right" title trigger="hover">
                <img :src="scope.row.galleryUrl" style="max-height: 800px; max-width: 800px" />
                <img slot="reference" :src="scope.row.galleryUrl" style="max-height: 50px; max-width: 50px" />
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <div class="pageblock">
          <el-pagination @size-change="imghandleSizeChange" @current-change="imghandleCurrentChange" :current-page="imgpage" :page-sizes="[10, 30, 50, 100]" :page-size="imgpageSize" layout="total, sizes, prev, pager, next, jumper" :total="imgtotalCount"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 下载模版 -->
    <el-dialog title="导出公示模版" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :style="'margin-top:0px;left:' + initLeft()" :visible.sync="dialogExportfileVisible">
      <el-form ref="exportfileModel" :key="exportfilKey" :rules="exportfileRules" label-width="180px" :model="exportfileModel">
        <el-form-item label="公示开始时间" prop="publicityStartTime">
          <el-date-picker v-model="exportfileModel.publicityStartTime" type="date" placeholder="请选择公示开始时间" value-format="timestamp" format="MM-dd" :picker-options="pickerOptions0" @change="changePublicityStartTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="公示结束时间" prop="publicityEndTime">
          <el-date-picker v-model="exportfileModel.publicityEndTime" type="date" placeholder="请选择公示结束时间" value-format="timestamp" format="MM-dd" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="镇（办事处）举报电话" prop="townshipTel">
          <el-input size="medium" v-model="exportfileModel.townshipTel" placeholder="请输入镇（办事处）举报电话"></el-input>
        </el-form-item>
        <el-form-item label="区卫健委举报电话" prop="districtTel">
          <el-input size="medium" v-model="exportfileModel.districtTel" placeholder="请选择区卫健委举报电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogExportfileVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" :loading="exportfileBtnLoading" @click="onExportfileSubmit">确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 完成公示 -->
    <el-dialog title="审核" :visible.sync="dialogCompletePublicityFormVisible" :show-close="true" custom-class="dialog_wrap" @close="clearAuditList('completePublicityForm')" style="margin-top:0px;left: 0px;z-index: 2154;" class="logindialog" width="600px">
      <el-form ref="completePublicityForm" :rules="rules" label-width="130px" :model="completePublicityForm">
        <el-form-item label="是否通过">
          <el-radio v-model="completePublicityForm.action" label="2" @change="changeActionHandle">否</el-radio>
          <el-radio v-model="completePublicityForm.action" label="1" @change="changeActionHandle">是</el-radio>
          <!-- <span style="color:#B5BAC2;font-size:15px">*不通过请选择或输入不通过原因</span> -->
        </el-form-item>
        <el-form-item label="不通过原因：" prop="people_logout_reason_id" v-if="completePublicityForm.action==`2`">
          <el-select size="medium" ref="itemSelect" v-model="completePublicityForm.approve_opinion_id" placeholder="请选择不通过原因" @change="changeSelectHandle">
            <el-option v-for="item in completePublicityForm.noPassReasonList" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="不通过原因：" prop="approve_opinion" class="textarea is-required" v-if="completePublicityForm.action==`2`">
          <el-input type="textarea" maxlength="1000" :rows="4" placeholder="请输入不通过原因(最多可录入1000字)" v-model.trim="completePublicityForm.approve_opinion">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="审核意见：" prop="people_logout_reason_id" v-if="completePublicityForm.action==`1`">
          <el-select size="medium" ref="itemSelect" v-model="completePublicityForm.approve_opinion_id" placeholder="请选择审核意见" @change="changeSelectHandle">
            <el-option v-for="item in completePublicityForm.adoptReasonList" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核意见：" prop="approve_opinion" class="textarea is-required" v-if="completePublicityForm.action==`1`">
          <el-input type="textarea" maxlength="1000" :rows="4" placeholder="请输入审核意见(最多可录入1000字)" v-model.trim="completePublicityForm.approve_opinion">
          </el-input>
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogCompletePublicityFormVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" :loading="completePublicityBtnLoading" @click="onCompletePublicitySubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  systemcodeModule,
  parentregioninfoModule,
} from '@/request/systemmange.js'
import { publicityModule } from '@/request/newawardmanage.js'
import { regionModule } from '@/request/systemmange.js'
import baseUrl from '@/request/base.js'
import { sysframe } from '@/tools/sysframe.js'
import { permissionTool } from '@/tools/permissiontool.js'
import $ from 'jquery'
import store from '@/store'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import NationAwardParticulars from '../acceptmanage/NationAwardParticulars.vue'
import { downloadFile } from '@/request/utils/downloadexcel.js'
import * as imageConversion from 'image-conversion'
export default {
  components: {
    NationAwardParticulars,
  },
  props: [
    'valueID',
    'indexID',
    'markID',
    'markrewardRecord',
    'markpolicyMeasure',
    'markuser',
    'markshow',
    'markauditStatus',
    'filterShowdata',
  ],
  data() {
    var validateCallTitle = (rule, value, callback) => {
      if (this.operErrors.title) {
        callback(new Error(this.operErrors.title))
      } else {
        callback()
      }
      if (this.operErrors.orderWeight) {
        callback(new Error(this.operErrors.orderWeight))
      } else {
        callback()
      }
    }
    var validateCallApproveOpinion = (rule, value, callback) => {
      if (value == '') {
        if (this.completePublicityForm.action == '2') {
          callback(new Error('请输入未通过原因'))
        } else {
          callback(new Error('请输入审核意见'))
        }
      } else {
        callback()
      }
    }
    return {
      pickerOptions0: {
        disabledDate: (time) => {
          // if (
          //   this.exportfileModel.publicityEndTime != '' &&
          //   this.exportfileModel.publicityEndTime != null
          // ) {
          //   return (
          //     time.getTime() <
          //     this.exportfileModel.publicityStartTime - 3600 * 24 * 4 * 1000
          //   )
          // }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (
            this.exportfileModel.publicityStartTime != '' &&
            this.exportfileModel.publicityStartTime != null
          ) {
            return (
              time.getTime() <
              this.exportfileModel.publicityStartTime + 3600 * 24 * 4 * 1000
            )
          }
        },
      },
      //进来加载数据是否展示loading圈
      showDataLoading: true,
      tableHeight: 400, //tableView的高度
      //搜索
      searchForm: {
        policy_measure_id: 1,
        publicStatusList: [],
        nodeID: '',
        node_status_str: '',
        operator_region_level: '',
        keywords: '',
        id_number: '',
        publicity_end_time: '',
        region_level: 0,
        region_id: 0,
        value1: '',
        value: '',
        villagename: '',
      },
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      currentUserRegionLevel: 0,
      parentregioninfolist: {},
      options: [],
      props: {
        value: 'baseRegionID',
        label: 'baseRegionName',
        children: 'cities',
      },
      //导出
      exportfilKey: 1,
      exportfileBtnLoading:false,
      dialogExportfileVisible: false,
      exportfileModel: {
        publicityStartTime: '',
        publicityEndTime: '',
        townshipTel: '',
        districtTel: '',
      },
      exportfileRules: {
        publicityStartTime: [
          { required: true, message: '请选择公示开始时间', trigger: 'change' },
        ],
        publicityEndTime: [
          { required: true, message: '请选择公示结束时间', trigger: 'change' },
        ],
        townshipTel: [
          {
            required: true,
            message: '请输入镇（办事处）举报电话',
            trigger: 'change',
          },
        ],
        districtTel: [
          {
            required: true,
            message: '请输入区卫健委举报电话',
            trigger: 'change',
          },
        ],
      },
      //公示图集参数
      dialogImglistVisible: false,
      gallerylist: [],
      imgpage: 1,
      imgpageSize: 10,
      imgtotalCount: 0,
      showDataLoadingimg: false,
      lookGalleryModel: {
        imgapplyRecordID: 0,
      },
      gallery_type: 3, //图片类型（1乡级；2区级;3村级）
      //权限
      lsp: [],
      permission: {
        isHavetownshippublicitylistwordPermission: false,
        isHaveSubmitPermission: false,
        isHaveFinishPermission: false,
        lookvillageshipapplypublicitygalleryinfolist003: false,
      },
      //完成公示审核
      multipleSelection: [], //多选
      completePublicityBtnLoading: false,
      dialogCompletePublicityFormVisible: false,
      completePublicityForm: {
        apply_record_ids: '',
        user_ids: '',
        policy_measure_id: '1',
        action: '2',
        approve_opinion_id: '',
        approve_opinion: '',
        noPassReasonList: [],
        adoptReasonList: [],
        curr_node_ids:''
      },
      rules: {
        approve_opinion: [{ validator: validateCallApproveOpinion }],
      },
      //1.受理登记 公示；2.年审审核；3.档案管理 4其他
      auditRecordType: 1,

      //旧
      markshowID: 0,
      markauditStatusID: 0,
      markpolicyMeasureID: 0,
      markuserID: 0,
      markrewardRecordID: 0,
      mark: 1,
      keyindex: 0,

      size: '',
      disabled: false,
      loading: false,

      // 申请记录id
      applyRecordID: 0,

      show: false,
      //添加-修改
      operKey: 0,
      dialogVisible: false,
      dialogOperFormVisible: false,
      dialogdetailVisible: false,
      dialogdataFormVisible: false,
      applyaudituserlist: [],
      operbuttonloading: false,
      operbuttondisabled: false,
      villageList: [],
      countryList: [],
      p_region_id: '',
      region_level: '',
      //详情
      detailKey: 1,
      dialogDetailFormVisible: false,
      detaiForm: {
        detail: '',
      },
      childListlist: [],
      editstep: 1,
      uploadUrl: '',
      uploadheaders: {},
      isMultiple: true,
      list: [],
      sourceType: 2,
      tiem: '',
      sign: '',
      fileList: [],
      authenStatus: false,
      uploadList: [],
      uploadNum: 0,

      //审核
      dialogFormVisible: false,
      applycheck: {
        mark: 3,
        type: 2,
        policy_measure_ids: '[0]',
        apply_record_ids: '[]',
        user_ids: '[]',
        policy_measure_id: 3,
        is_approve_pass: 1,
      },
    }
  },
  created: async function () {
    await this.getPublicStatusList(this.searchForm.policy_measure_id)
    this.currentUserRegionLevel = parseInt(store.getters.adminRegionLevel)
    await this.getparentregioninfo()
    this.dealAdministrativeDivision()
    await this.getApplyAuditUserList(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords,
      this.searchForm.id_number,
      this.searchForm.policy_measure_id,
      this.searchForm.region_level,
      this.searchForm.region_id,
      this.searchForm.publicity_end_time,
      this.searchForm.node_status_str,
      this.searchForm.operator_region_level
    )

    this.p_region_id = store.getters.adminRegionID
    this.region_level = store.getters.adminRegionLevel

    //上传公示照片
    let plat_form = 3
    this.sign = rsa.signString(
      baseconfig.v + String(plat_form) + '~AUF',
      rsaBasicModuleConfig.clientPrivateKey
    )
    //时间戳
    this.tiem = rsa.encryptString(
      String(publicFun.gettimestamp()),
      rsaBasicModuleConfig.serverPublicKey
    )
    this.uploadUrl = baseUrl.basic + 'uploadfile'
    this.uploadheaders = {
      v: baseconfig.v,
      platform: 3,
    }


    this.getSystemcodeinfogetlist(13)
    this.getSystemcodeinfogetlist(9)
    this.getparentregioninfo()
    this.tableHeight =
      $('.tab-content').height() -
      30 -
      $('.searchcontent').outerHeight(true) -
      $('.pageblock').outerHeight(true)
  },
  filters: {
    getRemainingDays(value) {
      return publicFun.getRemainingNumberDays(value)
    },
    dateFormate(value) {
      return publicFun.timestampToTime(value).substring(0, 10)
    },
  },

  mounted: function () {},
  methods: {
    dealPermission() {
      // 导出公式列表
      this.permission.isHavetownshippublicitylistwordPermission =
        permissionTool.isHavePermission(
          'villageshippublicitylistword',
          this.lsp
        )
      // 上传照片
      this.permission.isHaveSubmitPermission = permissionTool.isHavePermission(
        'applybatcheditpublicitystatus3',
        this.lsp
      )
      // 完成公示
      this.permission.isHaveFinishPermission = permissionTool.isHavePermission(
        'applybatchsubmitforapprocal12',
        this.lsp
      )
      this.permission.lookvillageshipapplypublicitygalleryinfolist003 =
        permissionTool.isHavePermission(
          'lookvillageshipapplypublicitygalleryinfolist',
          this.lsp
        )
    },
    //复选框禁用
    selectable(row) {
      //索引是从0开始，条件1是指只有第2行数据不被禁用  
      if(row.publicityStatus == 4 || row.publicityStatus == 7 || row.publicityStatus == 10){
        var remainingCount = row.publicityEndTime - new Date().getTime(); //时间差的毫秒数
        if (remainingCount>0) {
          return false;  //不禁用
        }else{
          return true;  //不禁用
        }
      }else {
        return true;  //禁用
      }
    },

    initLeft() {
      return sysframe.getSideBarLeft()
    },
    async getPublicStatusList(policy_measure_id) {
      await publicityModule
        .publicstatuslist(policy_measure_id)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                response.data.result.forEach((obj) => {
                  obj.nodeID = obj.nodeID * 1
                })
                this.searchForm.nodeID = response.data.result[0].nodeID;
                this.searchForm.node_status_str = response.data.result[0].nodeStatus;
                this.searchForm.operator_region_level = response.data.result[0].operatorRegionLevel;
                this.searchForm.publicStatusList = response.data.result
              }
              break
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    //获取搜索框的不通过原因下拉框
    async getSystemcodeinfogetlist(mark) {
      await systemcodeModule
        .systemcodeinfogetlist(mark)
        .then((response) => {
          console.log(1111222, response)
          switch (response.data.code) {
            case 100:
              {
                if (mark == 13) {
                  this.completePublicityForm.noPassReasonList =
                    response.data.result
                } else if (mark == 9) {
                  this.completePublicityForm.adoptReasonList =
                    response.data.result
                }
              }
              break
          }
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    // 获取当前区划所有父级信息详情 HYT
    async getparentregioninfo() {
      await parentregioninfoModule
        .parentregioninfo()
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                this.searchForm.value1 = response.data.result.villageName
                this.parentregioninfolist = response.data.result
                this.getSearchRegionList([], 0)
              }
              break
            case 101:
              {
                this.getSearchRegionList([], 0)
              }

              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    changeNodeHandle(val) {
      if (val) {
        this.searchForm.publicStatusList.forEach((obj) => {
          if (obj.nodeID == val) {
            this.searchForm.node_status_str = obj.nodeStatus
            this.searchForm.operator_region_level = obj.operatorRegionLevel
          }
        })
      } else {
        this.searchForm.node_status_str = ''
        this.searchForm.operator_region_level = ''
      }
      this.lsp = []
      this.dealPermission()
    },
    handleCateChange() {
      console.log(1111)
    },

    handleItemChange(val) {
      this.values = val
      // console.log(val)
      let valSize = val.length
      let that = this
      if (valSize == 1) {
        //   console.log(that.options)
        //第2级节点获取
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            that.getSearchRegionList(val, r.value)
            return
          }
        })
      }
      if (valSize == 2) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                that.getSearchRegionList(val, r0.value)
                return
              }
            })
          }
        })
      }
      if (valSize == 3) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                r0.children.forEach(function (r1, i1) {
                  if (r1.value === val[2]) {
                    that.getSearchRegionList(val, r1.value)
                    return
                  }
                })
              }
            })
          }
        })
      }
      if (valSize == 4) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                r0.children.forEach(function (r1, i1) {
                  if (r1.value === val[2]) {
                    r1.children.forEach(function (r2, i2) {
                      if (r2.value === val[3]) {
                        that.getSearchRegionList(val, r2.value)
                        return
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
    },
    //获取城市列表
    async getSearchRegionList(currentIds, p_region_id) {
      let currentIdsSize = currentIds.length
      let region_level = currentIdsSize + 1
      let this_is = this
      await regionModule
        .regioninfogetlist(region_level, p_region_id)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                if (region_level == 1) {
                  this_is.options = []
                  response.data.result.forEach(function (r, i) {
                    if (r.baseRegionID == 410000000000) {
                      this_is.options.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    }
                  })
                }
                if (region_level == 2) {
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 2) {
                    cities.push({
                      value: this.parentregioninfolist.cityID,
                      label: this.parentregioninfolist.cityName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }

                  this_is.options.forEach(function (r, index) {
                    if (r.value === currentIds[0]) {
                      this_is.options[index].children = cities
                    }
                  })
                }
                if (region_level == 3) {
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 3) {
                    cities.push({
                      value: this.parentregioninfolist.districtID,
                      label: this.parentregioninfolist.districtName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value === currentIds[1]) {
                          this_is.options[i0].children[i1].children = cities
                        }
                      })
                    }
                  })
                }
                if (region_level == 4) {
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 4) {
                    cities.push({
                      value: this.parentregioninfolist.townshipID,
                      label: this.parentregioninfolist.townshipName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value == currentIds[1]) {
                          console.log(i1, currentIds[1], r1.value)
                          // this_is.options[i0].children[i1].children = cities;
                          this_is.options[i0].children[i1].children.forEach(
                            function (r2, i2) {
                              if (r2.value === currentIds[2]) {
                                this_is.options[i0].children[i1].children[
                                  i2
                                ].children = cities
                              }
                            }
                          )
                        }
                      })
                    }
                  })
                }
                if (region_level == 5) {
                  let cities = new Array()
                  response.data.result.forEach(function (r, i) {
                    cities.push({
                      value: r.baseRegionID,
                      label: r.baseRegionName,
                    })
                  })
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value == currentIds[1]) {
                          console.log(i1, currentIds[1], r1.value)
                          this_is.options[i0].children[i1].children.forEach(
                            function (r2, i2) {
                              if (r2.value === currentIds[2]) {
                                this_is.options[i0].children[i1].children[
                                  i2
                                ].children.forEach(function (r3, i3) {
                                  if (r3.value === currentIds[3]) {
                                    this_is.options[i0].children[i1].children[
                                      i2
                                    ].children[i3].children = cities
                                  }
                                })
                              }
                            }
                          )
                        }
                      })
                    }
                  })
                }
              }
              break
          }
        })
        .catch((error) => {
          console.log('error', error)
          this.loading = false
        })
    },

    editFunds(row) {
      this.keyindex++
      this.dialogdataFormVisible = true
      this.applyRecordID = row.applyRecordID
      //审核
      this.markrewardRecordID = row.applyRecordID
      this.markpolicyMeasureID = this.completePublicityForm.policy_measure_id
      this.markuserID = row.userID
      this.markauditStatusID = 0
      //展示审核
      this.markshowID = 7
    },
    clearlookoverList() {
      /*
      this.getApplyAuditUserList(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords,
      this.searchForm.id_number,
      this.searchForm.policy_measure_id,
      this.searchForm.region_level,
      this.searchForm.region_id,
      this.searchForm.publicity_end_time,
    this.searchForm.node_status_str,
        this.searchForm.operator_region_level,
    )
    */
    },

    dealAdministrativeDivision(count) {
      if (store.getters.adminRegionLevel == 5) {
        this.searchForm.region_id = this.parentregioninfolist.villageID
        this.searchForm.region_level = 5
      } else {
        let villageID = 0
        let regionLevel = 0
        if (this.searchForm.value != '') {
         if (this.searchForm.value.length <= 4) {
            this.$message.error('请选择村级的区划单位')
            return
          } else {
            villageID = this.searchForm.value[this.searchForm.value.length - 1]
            regionLevel = this.searchForm.value.length
          }
        } else {
          villageID = 0
          regionLevel = 0
        }
        this.searchForm.region_id = villageID
        this.searchForm.region_level = regionLevel
      }
      if (count == 0) {
        this.totalCount = 0
      }

      this.getApplyAuditUserList(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords,
        this.searchForm.id_number,
        this.searchForm.policy_measure_id,
        this.searchForm.region_level,
        this.searchForm.region_id,
        this.searchForm.publicity_end_time,
        this.searchForm.node_status_str,
        this.searchForm.operator_region_level
      )
    },
    getTypedata(val) {
      this.dialogdataFormVisible = val
      this.dealAdministrativeDivision()
      // this.getApplyAuditUserList(
      //   this.pageIndex,
      //   this.pageSize,
      //   this.searchForm.keywords,
      //   this.searchForm.id_number,
      //   this.searchForm.policy_measure_id,
      //   this.searchForm.region_level,
      //   this.searchForm.region_id,
      //   this.searchForm.publicity_end_time,
      //   this.searchForm.node_status_str,
      //   this.searchForm.operator_region_level
      // )
    },
    submitUpload() {
      if (this.multipleSelection == '') {
        this.$message.error('请选择申请人')
        this.authenStatus = 0
        return
      } else {
        // let state = 1
        // this.multipleSelection.forEach((e) => {
        //   if (e.publicityStatus != 1) state = 2
        // })
        // if (state == 2) {
        //   this.$message.error('请选择未公示的申请人')
        //   this.authenStatus = 0
        //   return
        // } else {
        //   this.authenStatus = 1
        // }
        this.authenStatus = 1
      }
      //this.$refs.upload.submit();
    },

    //详情列表
    async getApplyAuditUserList(
      page,
      page_size,
      key_words,
      id_number,
      policy_measure_id,
      region_level,
      region_id,
      publicity_end_time,
      node_status_str,
      operator_region_level
    ) {
      if (publicity_end_time == '' || publicity_end_time == null) {
        publicity_end_time = 0
      }

      this.applyaudituserlist = []
      this.showDataLoading = true
      await publicityModule
        .applyaudituserlist(
          page,
          page_size,
          key_words,
          id_number,
          policy_measure_id,
          region_level,
          region_id,
          publicity_end_time,
          node_status_str,
          operator_region_level
        )
        .then((response) => {
          this.showDataLoading = false

          if (response.data.lsp !== null && response.data.lsp) {
            if (
              region_level == 5 &&
              node_status_str != null &&
              node_status_str != ''
            ) {
              this.lsp = response.data.lsp
              this.dealPermission()
            } else {
              this.lsp = response.data.lsp.filter((obj) => {
                return obj == 'lookvillageshipapplypublicitygalleryinfolist'
              })
              this.dealPermission()
            }
          } else {
            this.lsp = response.data.lsp.filter((obj) => {
              return obj == 'lookvillageshipapplypublicitygalleryinfolist'
            })
            this.dealPermission()
          }
          switch (response.data.code) {
            case 100:
              this.applyaudituserlist = response.data.result
              this.applyaudituserlist.forEach((e) => {
                e.applyTime = publicFun
                  .timestampToTime(e.applyTime)
                  .substring(0, 10)
                e.userBirthday = publicFun
                  .timestampToTime(e.userBirthday)
                  .substring(0, 10)
                e.marriageChanges = publicFun
                  .timestampToTime(e.marriageChanges)
                  .substring(0, 10)
              })
              this.totalCount = response.data.recordcount

              break
            case 101:
              this.applyaudituserlist = []
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch((error) => {
          console.log(error);
        })
    },

    //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.dealAdministrativeDivision()
      // this.getApplyAuditUserList(
      //   this.pageIndex,
      //   this.pageSize,
      //   this.searchForm.keywords,
      //   this.searchForm.id_number,
      //   this.searchForm.policy_measure_id,
      //   this.searchForm.region_level,
      //   this.searchForm.region_id,
      //   this.searchForm.publicity_end_time,
      //   this.searchForm.node_status_str,
      //   this.searchForm.operator_region_level
      // )
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.pageIndex = val
      this.dealAdministrativeDivision()
      // this.getApplyAuditUserList(
      //   this.pageIndex,
      //   this.pageSize,
      //   this.searchForm.keywords,
      //   this.searchForm.id_number,
      //   this.searchForm.policy_measure_id,
      //   this.searchForm.region_level,
      //   this.searchForm.region_id,
      //   this.searchForm.publicity_end_time,
      //   this.searchForm.node_status_str,
      //   this.searchForm.operator_region_level
      // )
    },
    async onSearchForm() {
      // this.totalCount = 0
      this.pageIndex = 1
      this.dealAdministrativeDivision(0)
      // this.getApplyAuditUserList(
      //   this.pageIndex,
      //   this.pageSize,
      //   this.searchForm.keywords,
      //   this.searchForm.id_number,
      //   this.searchForm.policy_measure_id,
      //   this.searchForm.region_level,
      //   this.searchForm.region_id,
      //   this.searchForm.publicity_end_time,
      //   this.searchForm.node_status_str,
      //   this.searchForm.operator_region_level
      // )
    },
    //关闭添加修改弹框时重置
    clearEditList(completePublicityForm) {
      this.$refs[completePublicityForm].clearValidate()
      console.log('sdhkas')

      this.clear()
      this.$forceUpdate()
    },
    clear() {
      this.completePublicityForm.noPassReasontext = ''
      this.completePublicityForm.noPassReason = ''
      this.completePublicityForm.is_audit_pass = '0'
    },
    // 批量
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    oncheckList() {
      this.dialogFormVisible = true
    },
    checked(row) {},

    //上传公示照片
    beforeUpload(file) {
      // 上传前 文件校验
      this.tiem = rsa.encryptString(
        String(publicFun.gettimestamp()),
        rsaBasicModuleConfig.serverPublicKey
      )
      if (this.multipleSelection == '') {
        this.$message.error('请选择申请人')
        return false
      } else {
        const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension =
          testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png'
        if (!extension) {
          if (!extension) {
            this.$message({
              message: '只能上传JPG、JPEG、PNG格式的图片!',
              type: 'error',
            })
          }
          return extension // 返回false不会自动上传
        } else {
          return new Promise((resolve, reject) => {
            //项目要求是大于1MB的图片进行压缩，可根据项目情况自行判断
            if (file.size > 1 * 1024 * 1024) {
              const loading = this.$loading({
                lock: true,
                text: '压缩中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.8)',
              })
              //  const imageConversion = require("image-conversion");
              // console.log('压缩前', file) //压缩图片到0.7模糊度
              imageConversion.compressAccurately(file, 1024).then((res) => {
                console.log('压缩后' + res.size / 1024 + 'K')
                //  res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
                loading.close()
                resolve(res)
              })
            } else {
              resolve(file)
            }
          })
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    handFileChange(files, fileList) {
      console.log('cccccccccccccccc')
      var upload_img = document.getElementsByClassName('upload-demo')
      if (upload_img && upload_img.length > 0) {
        var upload = upload_img[0].getElementsByTagName('input')
        if (
          upload &&
          upload.length > 0 &&
          upload[0].files &&
          upload[0].files.length > 0
        ) {
          this.uploadNum = upload[0].files.length
          console.log(this.uploadNum)
        }
      }
    },
    haneditVideoSuccess(res) {
      //获取上传图片地址
      if (res.code == 100) {
        for (let i = 0; i < res.result.length; i++) {
          var imgObj = {
            source_img_url: res.result[i].imgUrl,
          }
          this.uploadList.push(imgObj)
        }
        if (this.uploadList.length == this.uploadNum) {
          let apply_record_ids = []
          let user_ids = []
          this.multipleSelection.forEach((e) => {
            apply_record_ids.push(e.applyRecordID)
            user_ids.push(e.userID)
          })
          this.applybatcheditpublicitystatus(
            `[` + apply_record_ids.toString() + `]`,
            `[` + user_ids.toString() + `]`,
            this.completePublicityForm.policy_measure_id,
            JSON.stringify(this.uploadList),
            this.searchForm.node_status_str
          )
          this.uploadList = []
        }
      } else {
        this.$message.error(res.message)
        this.$refs['my-upload'].clearFiles()
      }
    },

    //申报审核-批量修改公示状态
    async applybatcheditpublicitystatus(
      apply_record_ids,
      user_ids,
      policy_measure_id,
      gallery_json,
      publicity_status
    ) {
      await publicityModule
        .applybatcheditpublicitystatus(
          apply_record_ids,
          user_ids,
          policy_measure_id,
          gallery_json,
          publicity_status
        )
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                this.dealAdministrativeDivision()
                // this.getApplyAuditUserList(
                //   this.pageIndex,
                //   this.pageSize,
                //   this.searchForm.keywords,
                //   this.searchForm.id_number,
                //   this.searchForm.policy_measure_id,
                //   this.searchForm.region_level,
                //   this.searchForm.region_id,
                //   this.searchForm.publicity_end_time,
                //   this.searchForm.node_status_str,
                //   this.searchForm.operator_region_level
                // )

                const h = this.$createElement
                this.$notify({
                  title: '成功',
                  message: h('span', response.data.message),
                  type: 'success',
                })
              }
              break
            case 101:
            case 103:
              this.$message.error(response.data.message)
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch(function (error) {})
    },

    // 导出
    exportfile() {
      this.exportfileModel.publicityStartTime = ''
      this.exportfileModel.publicityEndTime = ''
      this.exportfileModel.townshipTel = ''
      this.exportfileModel.districtTel = ''
      this.exportfilKey++
      this.dialogExportfileVisible = true
    },

    changePublicityStartTime(){
      this.exportfileModel.publicityEndTime = ''
    },

    onExportfileSubmit() {
      this.$refs.exportfileModel.validate(async (valid) => {
        if (valid) {
          let region_level
          let villageID
          if (
            this.searchForm.region_id == '' ||
            this.searchForm.region_id == null
          ) {
            villageID = 0
            region_level = 0
          } else {
            villageID = this.searchForm.region_id
            region_level = this.searchForm.region_level
          }

          const adminToken = store.getters.adminID
          var paras = {
            mark: 3,
            key_words: this.searchForm.keywords,
            id_number: this.searchForm.id_number,
            policy_measure_id: this.searchForm.policy_measure_id,
            node_status_str: this.searchForm.node_status_str,
            operator_region_level: this.searchForm.operator_region_level,
            region_level: region_level,
            region_id: villageID,
            publicity_start_time: this.exportfileModel.publicityStartTime,
            publicity_end_time:
              this.exportfileModel.publicityEndTime + 24 * 60 * 60 * 1000 - 1,
            township_tel: this.exportfileModel.townshipTel,
            district_tel: this.exportfileModel.districtTel,
            timestamp: rsa.encryptString(
              String(publicFun.gettimestamp()),
              rsaBasicModuleConfig.serverPublicKey
            ),
            _sign: rsa.signString(
              baseconfig.v + adminToken + '~cv1qQOWHRIPi',
              rsaBasicModuleConfig.clientPrivateKey
            ),
          }

          this.exportfileBtnLoading = true
          downloadFile('v2/publicitylistword', 'docx', paras, '申报公示名单列表').then(
            (res) => {
              this.exportfileBtnLoading = false
              this.dialogExportfileVisible = false
            }
          ).catch(error=>{
            this.exportfileBtnLoading = false
            this.$message.error(error.message);
          })


        } else {
          return false
        }
      })
    },
    //图集
    async getGalleryl(row) {
      this.dialogImglistVisible = true
      this.lookGalleryModel.imgapplyRecordID = row.applyRecordID
      this.imgpage
      await this.getapplypublicitygalleryinfolist(
        this.imgpage,
        this.imgpageSize,
        this.lookGalleryModel.imgapplyRecordID,
        this.gallery_type
      )
    },
    //更改每页显示条数
    async imghandleSizeChange(val) {
      this.imgpageSize = val
      this.imgpage = 1
      await this.getapplypublicitygalleryinfolist(
        this.imgpage,
        this.imgpageSize,
        this.lookGalleryModel.imgapplyRecordID,
        this.gallery_type
      )
    },
    //设置当前页
    async imghandleCurrentChange(val) {
      this.imgpage = val
      await this.getapplypublicitygalleryinfolist(
        this.imgpage,
        this.imgpageSize,
        this.lookGalleryModel.imgapplyRecordID,
        this.gallery_type
      )
    },
    async getapplypublicitygalleryinfolist(
      page,
      pagesize,
      apply_record_id,
      gallery_type
    ) {
      this.showDataLoadingimg = true
      await publicityModule
        .applypublicitygalleryinfolist(
          page,
          pagesize,
          apply_record_id,
          gallery_type
        )
        .then((response) => {
          this.showDataLoadingimg = false
          switch (response.data.code) {
            case 100:
              this.gallerylist = response.data.result
              this.imgtotalCount = response.data.recordcount

              break
            case 101:
              this.gallerylist = []
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch((error) => {})
    },

    //完成公示
    completeCheckHandle() {
      if (this.multipleSelection == '') {
        this.$message.error('请选择申请人')
        return
      }
      let apply_record_ids = []
      let user_ids = []
      let curr_node_ids = []
      this.multipleSelection.forEach((e) => {
        apply_record_ids.push(e.applyRecordID)
        user_ids.push(e.userID)
        curr_node_ids.push(e.currNodeID)
      })
      this.completePublicityForm.apply_record_ids =
        `[` + apply_record_ids.toString() + `]`
      this.completePublicityForm.user_ids = `[` + user_ids.toString() + `]`
      this.completePublicityForm.curr_node_ids = `[` + curr_node_ids.toString() + `]`
      this.dialogCompletePublicityFormVisible = true
    },
    clearAuditList(ref) {
      this.completePublicityForm.apply_record_ids = ''
      this.completePublicityForm.user_ids = ''
      this.completePublicityForm.action = '2'
      this.completePublicityForm.approve_opinion_id = ''
      this.completePublicityForm.approve_opinion = ''
      this.completePublicityForm.curr_node_ids = ''
      this.$refs[ref].clearValidate()
    },
    changeActionHandle() {
      this.completePublicityForm.approve_opinion_id = ''
      this.completePublicityForm.approve_opinion = ''
      this.$refs.completePublicityForm.clearValidate()
    },
    changeSelectHandle(val) {
      if (this.completePublicityForm.action == 2) {
        this.completePublicityForm.approve_opinion =
          this.completePublicityForm.noPassReasonList.find(
            (item) => item.systemCodeID == val
          ).systemCodeName
      } else {
        this.completePublicityForm.approve_opinion =
          this.completePublicityForm.adoptReasonList.find(
            (item) => item.systemCodeID == val
          ).systemCodeName
      }
    },
    onCompletePublicitySubmit() {
      this.$refs.completePublicityForm.validate(async (valid) => {
        if (valid) {
          this.completePublicityBtnLoading = true
          var approveOpinionID = 0
          if (
            this.completePublicityForm.approve_opinion_id == '' ||
            this.completePublicityForm.approve_opinion_id == null
          ) {
            approveOpinionID = 0
          } else {
            approveOpinionID = this.completePublicityForm.approve_opinion_id
          }

          await publicityModule
            .applybatchaudit(
              this.completePublicityForm.apply_record_ids,
              this.completePublicityForm.user_ids,
              this.completePublicityForm.policy_measure_id,
              this.completePublicityForm.action,
              approveOpinionID,
              this.completePublicityForm.approve_opinion,
              this.completePublicityForm.curr_node_ids
            )
            .then((response) => {
              this.completePublicityBtnLoading = false
              switch (response.data.code) {
                case 100:
                  {
                    this.dialogCompletePublicityFormVisible = false
                    this.dealAdministrativeDivision()
                    // this.getApplyAuditUserList(
                    //   this.pageIndex,
                    //   this.pageSize,
                    //   this.searchForm.keywords,
                    //   this.searchForm.id_number,
                    //   this.searchForm.policy_measure_id,
                    //   this.searchForm.region_level,
                    //   this.searchForm.region_id,
                    //   this.searchForm.publicity_end_time,
                    //   this.searchForm.node_status_str,
                    //   this.searchForm.operator_region_level
                    // )
                    const h = this.$createElement
                    this.$notify({
                      title: '成功',
                      message: h('span', response.data.message),
                      type: 'success',
                    })
                  }
                  break
                case 101:
                case 103:
                  this.$message.error(response.data.message)
                  break
                case 100002:
                  this.$message.error(baseconfig.no_permission_message)
                  break
                case 102:
                  this.$message.error(response.data.message)
                  break
                default:
                  this.$message.error(response.data.message)
                  break
              }
            })
            .catch(function (error) {
              this.completePublicityBtnLoading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.pageblock {
  text-align: right;
  margin-top: 5px;
}

.tablecolumn {
  margin-left: 10px;
  margin-top: 5px;
}

.addorganization .el-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.pm_p1 {
  min-width: 100% !important;
  /* width: 100%; */
}
</style>

